export default "__VITE_ASSET__Dcyqk9tJ__"